import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChildrenPropType from 'lib/CustomPropTypes/children';
import styles from './styles.module.scss';

// eslint-disable-next-line react/prop-types
const InfoButton = ({ handleClick }) => (
  <button className={classNames('css-reset-btn ml1 va-mid', styles.infoIconButton)} type="button" onClick={handleClick}>
    <span className={classNames('icon', 'icon-info', styles.infoIcon)} />
  </button>
);

class ModalDisclaimer extends Component {
  static propTypes = {
    children: ChildrenPropType,
    disclaimerDetailText: PropTypes.string.isRequired,
  };

  static defaultProps = {
    children: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClick = () => this.setState(({ open }) => ({ open: !open }));

  closeModal = () => this.setState({ open: false });

  renderDisclaimerBox = (disclaimerDetailText) => (
    <div
      className={classNames(styles.disclaimerBox, 'absolute z-1 top3 ml0-l ml8-m mh0-m')}
      data-test="disclaimer-box"
    >
      <button type="button" className="css-reset-btn absolute" onClick={this.closeModal}>
        <span className="icon icon-close f2" />
      </button>
      <p className="f2 mb5 mh6 mt7 gray-100 publico-txt lh-copy">
        {disclaimerDetailText}
      </p>
    </div>
  )

  render() {
    const { open } = this.state;
    const { children, disclaimerDetailText } = this.props;

    return (
      <div className="relative dif content-center gray-80">
        <div className="relative">
          {children}
          <InfoButton handleClick={this.handleClick} />
          {open && this.renderDisclaimerBox(disclaimerDetailText)}
        </div>
      </div>
    );
  }
}

export default ModalDisclaimer;
